import { Switch, Route, Redirect } from "react-router-dom";
import "../../../_metronic/_assets/sass/pages/login/login-1.scss";
import Login from "./Login";
import Signin from "./Signin";
import AlterarSenha from "./AlterarSenha";
import EsqueceuSenha from "./EsqueceuSenha";
import CodigoSenha from "./CodigoSenha";
import AuthFooter from "../../components/AuthFooter";

export default function AuthPage() {
    return (
        <div class="authContainer">
            <Switch>
                <Route exact path="/" component={Login} />
                <Route path="/esqueceu-senha" component={EsqueceuSenha} />
                <Route path="/esqueceu-senha-codigo" component={CodigoSenha} />
                <Route path="/alterar-senha" component={AlterarSenha} />
                <Route path="/signin" component={Signin} />
                <Redirect to="/" />
            </Switch>

            <AuthFooter />
        </div>
    );
}
